import { Environment } from '@moawen-workspace/shared';

export const environment: Environment = {
  production: false,
  envcode: 'dev',
  baseUrl: 'https://moawen-agency-api.fit-infotech.com/api',
  appName: 'agency',
};
